module.exports = __webpack_public_path__ + "img/zabbix.2e83c23c.png";